module.exports = __webpack_public_path__ + "img/card10.40907d0f.png";